import React from "react";
import { Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import TabContent from "./tabContent";
import "./manageFirmwares.scss";

const ManageUpdates = () => {
  return (
    <div className="ManageFirmwares_container">
      <div className="ManageFirmwares_content">
        <div className="ManageFirmwares_header">
          <h1>Manage Updates</h1>
        </div>
        <div className="ManageFirmwares_body">
          <Row>
            <Col sm={12}>
              <Tabs defaultActiveKey="firmwares" className="mb-3">
                <Tab eventKey="firmwares" title="Firmwares">
                  <TabContent isFirmwareUpload={true}></TabContent>
                </Tab>
                <Tab eventKey="iot-agents" title="IOT Agents">
                  <TabContent isFirmwareUpload={false}></TabContent>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ManageUpdates;
